import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { of } from 'rxjs';
import { map,  catchError } from 'rxjs/operators';
import * as moment from 'moment';
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";
import { DataService } from "../services/dataService";
import { DocumentType } from "../models/documentType.model";
import { Location } from ".././models/location.model";
import { Document } from "../models/document.model";
import { Role } from ".././models/role.model";
declare var $: any;
declare let jsPDF;
@Component({
    selector: "jax-judicialdocumentreport",
    templateUrl: "./judicialdocumentreport.component.html"
})

export class JudicialDocumentReportComponent {
    public data;
    public caseNumber: string;
    public sortBy = "UploadedDate";
    public sortOrder = "desc";
    public rowsOnPage = 20;
    private userID: number;
    private currentUser: any;
    public reportCriteria: any = {};
    public locations: Location[] = [];
    public roles: Role[] = [];
    public totalRecord = 0;
    public isCompleted = false;
    public errorMessage = "";
    public hasError = false;
    public searchReportsClicked: boolean = false;
    public searchCompleted: boolean = false;
    public validationMessage: ValidationMessage;
    public todayDate: string;

    
    public documentHistory: any = {};


    constructor(private dataService: DataService, private router: Router) {
    }

    public ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.userID = this.currentUser.UserId;
        }

        this.isCompleted = false;

        this.todayDate = moment(new Date()).format("YYYY-MM-DD");
        this.reportCriteria.StartDate = this.todayDate;
        this.reportCriteria.EndDate = this.todayDate;
        this.getLocation();
        this.getRole();
    }

    public onchange(pageEvent: any) {
        this.totalRecord = pageEvent.dataLength;
        this.rowsOnPage > 60 ? this.rowsOnPage = 20 : this.rowsOnPage = this.rowsOnPage;
    }

    public convertToPdf() {
        let pdf = new jsPDF('l', 'pt', 'a4');
        let options = {
            pagesplit: true
        };

        var columns = [
            { title: "Case #", dataKey: "CaseNumber" },
            { title: "Document Type", dataKey: "DocumentType" },
            { title: "Document Name", dataKey: "DocumentName" },
            { title: "Judicial Officer", dataKey: "JudicialName" },
            { title: "Uploaded On", dataKey: "UploadedDate" },
            { title: "Juvenile", dataKey: "Juveniles" },
            { title: "Hearing", dataKey: "Hearings" },
            { title: "Case Manager", dataKey: "CaseManagers" }
        ];

        var doc = new jsPDF('l', 'pt');


        doc.autoTable(columns,
            this.data,
            {
                styles: {},
                columnStyles: {
                    id: {}
                },
                createdCell(cell, data) {
                    // prevent 'null' as text in table columns
                    if (!cell.raw) {
                        cell.text = "";
                    }
                },
                margin: { top: 60 },
                addPageContent: function (data) {

                    doc.text("Report", 40, 30);
                }
            });
        doc.save("report.pdf");
    }

    public openPdf(documentId: number, documentName: string, documentTypeId: number, uploadedDate: Date) {
        var isJaxOnlyDocument = false;
        var date = new Date(2025, 3, 30, 23, 59, 59);
        if (documentTypeId === 37232555 && new Date(uploadedDate) > date)     
        {
            isJaxOnlyDocument = true;
        }
        this.dataService.sharedService.openPopupWindow();
        this.dataService.getPdf("document/document?documentID=" + documentId + "&documentName=" + encodeURIComponent(documentName) + "&isJaxOnlyDocument=" + isJaxOnlyDocument)
            .subscribe((res) => {                       
                    this.dataService.sharedService.displayPdf(res,documentName);
                },
                (error) => {
                    this.errorMessage = error.message;
                    this.isCompleted = true;
                    this.hasError = true;
                    this.dataService.sharedService.closePopupWindow();
                });
    }

    public observableSource = (keyword: any): Observable<any[]> => {
        let url: string = "Calendar/searchname?roleId=" + this.reportCriteria.role + "&nameLiteral=" + keyword;
        //let url: string = "Calendar/searchname?roleId=2653&nameLiteral=" + keyword;
        if (keyword) {
            return this.dataService.get(url)
                .map(res => {
                    let json = res;
                    return json;
                });
        } else {
            return of([]);
        }
    }

    public getLocation() {
        this.dataService.get("common/locations").subscribe(resp => {
                this.locations = resp;
                this.locations.unshift(new Location());
                this.reportCriteria.LocationId = 1;
            },
            (error) => {
            });
    }

    public searchReports() {

        this.searchReportsClicked = true;
        this.searchCompleted = false;
        this.data = "";
        this.totalRecord = 0;
        this.hasError = false;

        if (!this.validateSearchCriteria()) {

            this.reportCriteria.RoleId = 2;
            this.dataService.post("reports/judicialdocuments", JSON.stringify(this.reportCriteria)).subscribe(
                (response) => {
                    this.data = response;
                    this.totalRecord = this.data.length;
                    this.searchCompleted = true;
                    this.errorMessage = "";
                },
                (error) => {
                    this.errorMessage = error.message || error.message.Message || error.statusText;
                    this.searchCompleted = true;
                    this.hasError = true;
                });
        } else {
            this.searchReportsClicked = false;
        }
    }

    private validateSearchCriteria() {
        this.validationMessage = null;
        let msg = new ValidationMessage();
        msg.messageType = ValidationMessageType.Error;
        let isError = false;
        let errorMessage: string;
        errorMessage = "<ul>";

        if (this.reportCriteria.role === -1 || !this.reportCriteria.role) {
            isError = true;
            errorMessage = errorMessage + "<li>Role is required</li>";
        }

        if (this.reportCriteria.JudicialName == "undefined" || !this.reportCriteria.JudicialName) {
            isError = true;
            errorMessage = errorMessage + "<li>Name is required</li>";
        }

        if (this.reportCriteria.StartDate === "") {
            isError = true;
            errorMessage = errorMessage + "<li>Start date cannot be empty</li>";
        }

        if (this.reportCriteria.EndDate === "") {
            isError = true;
            errorMessage = errorMessage + "<li>End date cannot be empty</li>";
        }
        else if (this.reportCriteria.EndDate !== "" && this.reportCriteria.StartDate > this.reportCriteria.EndDate) {
            isError = true;
            errorMessage = errorMessage + "<li>Start date cannot be greater than end date</li>";
        }

        errorMessage = errorMessage + "</ul>";

        if (isError) {
            msg.message = errorMessage;
            this.validationMessage = msg;
        } else {
            $.fn.collapse("#search", "#reports");
        }

        return isError;
    }

    public clearSearch() {
        this.reportCriteria.role = "";
        this.reportCriteria.JudicialName = "";
        this.reportCriteria.LocationId = 1;
        this.reportCriteria.StartDate = this.todayDate;
        this.reportCriteria.EndDate = this.todayDate;
        this.data = "";
        this.searchReportsClicked = false;
        this.validationMessage = null;
        this.searchCompleted = false;
    }

    public getRole() {

        this.roles = [
            { Id: 1, Name: 'Attorney' },
            { Id: 2653, Name: "Judicial Officer" }];
        this.reportCriteria.role = 2653;
    }

    public canViewDocument() {
        if (this.currentUser.Security.search("vintJAXDocumentView") >= 0)
            return true;
        else
            return false;
}

}
